<div class="landing-login">
    <h2
        [style.--color-login-landing-header]="getHeaderColor(block.data.headTextColor)"
        class="landing-login__heading"
        [innerText]="block.data.heading"></h2>
    <div class="landing-login__subheading" [innerHTML]="block.data.subHeading"></div>
    <a
        class="btn btn-primary landing-login__cta-link"
        [href]="block.data.linkUrl"
        [style.backgroundColor]="block.data.btnColor || 'var(--color-primary)'"
        [attr.aria-label]="block.data.linkUrl"
        [ngClass]="{
            'landing-login--btn-text-color-white': block.data.btnTextColor === 'white',
            'landing-login--btn-text-color-black': block.data.btnTextColor === 'black',
        }">
        <span>{{ block.data.linkText }}</span>
    </a>
</div>
